import { Button } from "@/components/ui/button"
import { useNavigate } from "react-router-dom"
import Fullscreen from "./fullscreen"

interface FullscreenProps {
  children: React.ReactNode;
  buttons?: React.ReactNode;
  backTo: string;
}

export default function FullscreenForm({
  children,
  buttons,
  backTo,
}: FullscreenProps) {
  const navigate = useNavigate()

  const goBackOrTo = () => {
    if (history.length > 1) {
      navigate(-1)
    } else {
      navigate(backTo)
    }
  }

  return (
    <Fullscreen>
      <div className="flex flex-row justify-between p-4 px-8 shadow-sm">
        <div className="flex flex-row gap-2">
          <Button type="button" variant="outline" onClick={goBackOrTo}>
            Cancel
          </Button>
        </div>
        <div className="flex flex-row gap-2">{buttons}</div>
      </div>
      {children}
    </Fullscreen>
  )
}
